"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ADD_SEGMENT: function() {
        return ADD_SEGMENT;
    },
    DELETE_SEGMENT: function() {
        return DELETE_SEGMENT;
    },
    DUPLICATE_SEGMENT: function() {
        return DUPLICATE_SEGMENT;
    },
    GENERATE_SEGMENTS: function() {
        return GENERATE_SEGMENTS;
    },
    RANDOMISE_SEGMENT: function() {
        return RANDOMISE_SEGMENT;
    },
    RATE_SEGMENT: function() {
        return RATE_SEGMENT;
    },
    RESET_SEGMENTS: function() {
        return RESET_SEGMENTS;
    },
    SIMULATE_SEGMENT: function() {
        return SIMULATE_SEGMENT;
    },
    UPDATE_SEGMENT: function() {
        return UPDATE_SEGMENT;
    }
});
const ADD_SEGMENT = "ADD_SEGMENT";
const UPDATE_SEGMENT = "UPDATE_SEGMENT";
const DELETE_SEGMENT = "DELETE_SEGMENT";
const GENERATE_SEGMENTS = "GENERATE_SEGMENTS";
const RESET_SEGMENTS = "RESET_SEGMENTS";
const DUPLICATE_SEGMENT = "DUPLICATE_SEGMENT";
const RANDOMISE_SEGMENT = "RANDOMISE_SEGMENT";
const SIMULATE_SEGMENT = "SIMULATE_SEGMENT";
const RATE_SEGMENT = "RATE_SEGMENT";
